export const coursesSelector = (coursesObj) => {
  return Object.keys(coursesObj)
    .map((courseKey) => coursesObj[courseKey]);
};
